import { gql } from '@apollo/client';

export const LOGIN_USER = gql`
	mutation LoginUser($credentials: AutenticateUserDto!) {
		loginUser(credentials: $credentials) {
			access_token
			refresh_token
		}
	}
`;

// login(credentials: UserCredentials!): Success! //access/refresh одразу сетиться в кук
export const LOGIN_USER_V2 = gql`
	mutation LoginUserV2($credentials: UserCredentials) {
		login(credentials: $credentials) {
			success
		}
	}
`;